import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAtomValue } from 'jotai';

import { Tag } from 'tags/models/tags';
import {
  pageFilterAtom,
  rowsPerPageFilterAtom,
  rsimFiltersAtom,
  rsimSortingAtomWithStorage,
} from 'atoms/filters/rsim-products';
import { rSimProductsQueries } from 'src/rSimInventory/utils/rsimProductsQueries';

export const useRefreshRSimInventoryEntry = () => {
  const filters = useAtomValue(rsimFiltersAtom);
  const { tags, searchText, chosenIdType, ...otherFilters } = filters;
  const sorting = useAtomValue(rsimSortingAtomWithStorage);
  const rowsPerPage = useAtomValue(rowsPerPageFilterAtom);
  const page = useAtomValue(pageFilterAtom);

  const queryClient = useQueryClient();

  const queryKey = rSimProductsQueries.list({
    searchText,
    chosenIdType,
    tags,
    sorting,
    rowsPerPage,
    page,
    ...otherFilters,
  });

  const refreshTags = useCallback(
    async ({ cardId, tags }: { cardId: string; tags: Tag[] }) => {
      await queryClient.cancelQueries({ queryKey: queryKey });

      queryClient.setQueryData(queryKey, (oldData: any) => {
        const newData = {
          ...oldData,
          items: oldData?.items.map((simProfile: any) => {
            if (simProfile.euicc === cardId) {
              return { ...simProfile, tags: { items: tags, hasMore: false } };
            }

            return simProfile;
          }),
        };
        return newData;
      });
    },
    [queryClient, queryKey],
  );

  return {
    refreshTags,
  };
};
